<script>
    export let currentRoute;
    export let params;

</script>

<div style="width: 100%;; height: 100%;" class="w-100; h-100; d-flex justify-content-center align-items-center">
    <div style="width: 4rem; height: 4rem;" class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>